import {
  familyProIntakeEnquiryFormUri,
  familyProParentingAndPropertyExclCurrSitFormUri,
  familyProParentingAndPropertyFormUri,
  familyProParentingExclCurrSitFormUri,
  familyProParentingFormUri,
  familyProPropertyExclCurrSitFormUri,
  familyProPropertyFormUri,
  familyProQuestionnaireFormUri,
  SubmissionStatus,
} from "@smart/bridge-types-basic";
import { useLoadMatterSpecificForms } from "@smart/manage-gql-client-dom";
import { Gql } from "@smart/manage-gql-operations-dom";

export type GqlSubmission = Gql.SubmissionFieldsFragment;

export type GqlSubmissionSummary = Gql.SubmissionSummaryFieldsFragment;

export type GqlTracker = NonNullable<
  NonNullable<GqlSubmission["trackers"]>[number]
>;

export type AreaInfo = {
  name: string;
  displayName: string;
};

export const externalFormUris = [
  familyProQuestionnaireFormUri,
  familyProIntakeEnquiryFormUri,
  familyProPropertyFormUri,
  familyProParentingFormUri,
  familyProParentingAndPropertyFormUri,
  familyProParentingExclCurrSitFormUri,
  familyProParentingAndPropertyExclCurrSitFormUri,
  familyProPropertyExclCurrSitFormUri,
];

export type SubmissionTabOptions = "view" | "edit";

export type ExtendedGqlSubmission = GqlSubmissionSummary & {
  derivedSubmissionStatus: SubmissionStatus | "prefilled";
  typeOfMatter: "lead" | "matter" | undefined;
  matterTypeName: string;
};

export type MatterSpecificForm = NonNullable<
  ReturnType<typeof useLoadMatterSpecificForms>["result"]
>[number];

export type CellProps<I extends {}> = { row: { original: I } };

export const RESTORE_DELETED_FORM_TIMEOUT = 120000; // 2 minutes

export const baseLanguageKey = "en";
export const baseLanguageLabel = "English";

export const defaultSupportedLanguages = [
  { key: "ar", label: "Arabic" },
  { key: "zh", label: "Chinese" },
  { key: "fr", label: "French" },
  { key: "de", label: "German" },
  { key: "it", label: "Italian" },
  { key: "ja", label: "Japanese" },
  { key: "ko", label: "Korean" },
  { key: "pl", label: "Polish" },
  { key: "pt", label: "Portuguese" },
  { key: "ru", label: "Russian" },
  { key: "es", label: "Spanish" },
  { key: "vi", label: "Vietnamese" },
] as const;

export type DefaultLanguageKey =
  (typeof defaultSupportedLanguages)[number]["key"];

export type LanguageKey = typeof baseLanguageKey | DefaultLanguageKey;

export type SupportedLanguageOption = {
  key: LanguageKey;
  label: string;
};

export const getLanguageLabel = (
  key: string,
  supported?: SupportedLanguageOption[],
) =>
  supported?.find((language) => language.key === key)?.label ??
  defaultSupportedLanguages.find((language) => language.key === key)?.label ??
  key;

export type FormBuilderTabOptions = "questions" | "preview" | "share";

export type ReminderScheduleInput = {
  enabled?: boolean;
  effectiveFrom?: string;
  firstReminderDays?: number;
  timezone?: string;
  stopOnManualSend?: boolean;
  sendFollowUps?: boolean;
  repeatEveryDays?: number;
  maxFollowUps?: number;
};

export type ReminderScheduleValue = {
  [K in keyof ReminderScheduleInput]?: ReminderScheduleInput[K] | null;
};
